module.exports = __webpack_public_path__ + "f4dde6212855835e902c5c2467ba5e8b.woff2";